// extracted by mini-css-extract-plugin
export default {"image":"WaterImage_image__xryu7"};